import React, { useState, useEffect } from "react";
import { ListProject } from "./ListProject";

// const Output = ListProject

const Output = [
  [
    {
      key: "1",
      地域No: "01",
      地域名: "aaa",
      種類: "bbb",
      整理No: "ccc",
      プロジェクト名: "ddd",
    },
  ],
  [
    {
      key: "2",
      地域No: "01",
      地域名: "aaa",
      種類: "bbb",
      整理No: "ccc",
      プロジェクト名: "ddd",
    },
  ],
];

// console.log(Output);
// console.log(ListProject);
// console.log(Object.keys(Output[0][0])[0]);
// console.log(Object.keys(ListProject[0])[0]);

const listConfigs = [
  {
    title: "事業中",
    fields: ["地域名", "プロジェクト名", "種類", "実施主体", "税制支援（都市再生）",  "民都金融支援", "事業期間（年度）"],
    filter: (item) => item["状況"] === "事業中",
  },
  {
    title: "未着手",
    fields: ["地域名", "プロジェクト名", "種類", "税制支援（都市再生）",  "事業期間（年度）"],
    filter: (item) => item["状況"] === "未着手",
  },
];

const detailConfigs = [
  { title: "プロジェクト詳細", fields: ["プロジェクト名", "地域名", "種類", "整理No",  "内閣府No", "内閣府プロジェクト名", "内閣府プロジェクト名２", "特定地域整備計画No", "特定地域整備計画名", "補助金・交付金等", "その他", "実施主体", "事業期間（年度）", "状況", "都市再生特別地区", "民間都市再生事業計画認定", "税制支援（都市再生）", "税制支援（ウォーカブル）", "民都金融支援", "国際競争拠点都市整備事業", "区画整理再開発", "都市構造都市再生整備計画事業", "まちなかウォーカブル推進事業", "街路連立", "都市・地域交通戦略推進事業", "その他支援"] },



  { title: "地域名", fields: ["key", "種類", "整理No"] },
];

const DataSelection = ({ setFooterview }) => {
  const [field, setField] = useState(Object.keys(ListProject[0])[0]);
  // const [field, setField] = useState(Object.keys(Output[0][0])[0]);
  const [value, setValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [initialOutput, setInitialOutput] = useState([]);
  const [selected, setSelected] = useState(
    listConfigs.map(() => ({ field: "", value: "" }))
  );
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleShow = (item) => {
    setSelectedItem(item);
    setShowModal(true);
    // setFooterview(false)
  };
  const handleClose = () => setShowModal(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const output = ListProject.flat().filter((item) =>
      // const output = Output.flat().filter((item) =>
      Array.from(params).every(([key, value]) => item[key] === value)
    );
    setInitialOutput(output);

    const uniqueValues = [...new Set(output.map((item) => item[field]))];
    setValue(uniqueValues[0]);
  }, [field]);

  useEffect(() => {
    setSelected(
      listConfigs.map((config) => ({ field: config.fields[0], value: "" }))
    );
  }, []);

  useEffect(() => {
    const data = initialOutput.filter((item) => item[field] === value);
    setFilteredData(data);
  }, [field, value, initialOutput]);

  useEffect(() => {
    setSelected((prev) =>
      prev.map((select, idx) => ({
        ...select,
        value: [...new Set(initialOutput.map((item) => item[select.field]))][0],
      }))
    );
  }, [initialOutput]);

  const updateSelect = (idx, field, value) => {
    setSelected((prev) =>
      prev.map((select, selectIdx) =>
        selectIdx === idx
          ? {
              ...select,
              field,
              value:
                value ||
                [
                  ...new Set(
                    initialOutput
                      .filter(listConfigs[selectIdx].filter)
                      .map((item) => item[field])
                  ),
                ][0],
            }
          : select
      )
    );
  };

  return (
    <div>
      {listConfigs.map((config, configIdx) => (
        <div key={configIdx}>
          {console.log(configIdx)}
          <h2 className="text-2xl mb-2">{config.title}プロジェクト一覧</h2>
          <select onChange={(e) => updateSelect(configIdx, e.target.value)}>
            {config.fields.map((field) => (
              <option key={field} value={field}>
                {field}
              </option>
            ))}
          </select>
          <select
            onChange={(e) =>
              setSelected((prev) =>
                prev.map((select, selectIdx) =>
                  selectIdx === configIdx
                    ? { ...select, value: e.target.value }
                    : select
                )
              )
            }
          >
            {[
              ...new Set(
                initialOutput
                  .filter(config.filter)
                  .map((item) => item[selected[configIdx].field])
              ),
            ].map((value) => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </select>


          <table>
            <thead  class="items-center px-5 py-2">
              <tr>
                {config.fields.map((field) => (
                  <th key={field}>{field}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {initialOutput
                .filter(
                  (item) =>
                    item[selected[configIdx].field] ===
                    selected[configIdx].value
                )
                .filter(config.filter)
                .map((item, idx) => (
                  <tr class="hover:bg-gray-200 cursor-pointer bg-white bg-opacity-50 shadow p-5 items-center mb-5 rounded-lg" key={idx} onClick={() => handleShow(item)}>
                    {config.fields.map((field, fieldIdx) => (
                      <td key={fieldIdx}>{item[field]}</td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ))}

      {showModal && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto flex items-center justify-center max-h-[60%]  my-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
          <div className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full  max-w-[80%]">
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 w-full py-4">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3
                    className="text-lg leading-6 font-medium text-gray-900 py-[20%]"
                    id="modal-title"
                  >
                    Details
                  </h3>
                  <div className="mt-2">

                    {selectedItem &&
                      detailConfigs.map((config, idx) => (
                        <div key={idx}>
                          <h4>{config.title}</h4>
                          {config.fields.map((field) => (
                            <p key={field}>
                              <strong>{field}: </strong>
                              {selectedItem[field]}
                            </p>
                          ))}
                        </div>
                      ))}
                      <iframe width="560" height="315" src="https://www.youtube.com/embed/UbccXqm-s7M" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                className="mt-3 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3  sm:text-sm"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    // <div>
    //   <select value={field} onChange={(e) => setField(e.target.value)}>
    //     {Object.keys(ListProject[0]).map((key) => (
    //       // {Object.keys(Output[0][0]).map((key) => (
    //       <option key={key} value={key}>
    //         {key}
    //       </option>
    //     ))}
    //   </select>
    //   <select value={value} onChange={(e) => setValue(e.target.value)}>
    //     {[...new Set(initialOutput.map((item) => item[field]))].map((val) => (
    //       <option key={val} value={val}>
    //         {val}
    //       </option>
    //     ))}
    //   </select>

    //   {listConfigs.map((config, configIdx) => (
    //     <div key={configIdx}>
    //       <h2>{config.title}</h2>
    //       <table>
    //         <thead>
    //           <tr>
    //             {config.fields.map((field) => (
    //               <th key={field}>{field}</th>
    //             ))}
    //           </tr>
    //         </thead>
    //         <tbody>
    //           {filteredData.filter(config.filter).map((item, idx) => (
    //             <tr key={idx}>
    //               {config.fields.map((field, fieldIdx) => (
    //                 <td key={fieldIdx}>{item[field]}</td>
    //               ))}
    //             </tr>
    //           ))}
    //         </tbody>
    //       </table>
    //     </div>
    //   ))}
    // </div>
  );
};

export default DataSelection;
